import { AspectRatio } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import ReactPlayer from "react-player/vimeo";
import classes from "./VideoPlayer.module.css";
import { playerProps } from "./playerProps";

export function VimeoPlayer({
  videoSrc,
  isPortrait: isPortraitMode,
  isAutoPlaying = true,
}: {
  videoSrc?: string;
  isPortrait?: boolean;
  isAutoPlaying?: boolean;
}) {
  const defaultIsPortrait = useMediaQuery("screen and (orientation: portrait)");
  const isPortrait = isPortraitMode ?? defaultIsPortrait;

  return (
    <ReactPlayer
      {...playerProps}
      playing={isAutoPlaying}
      url={videoSrc}
      wrapper={({ children }) => {
        return (
          <AspectRatio
            h={isPortrait ? undefined : 380}
            ratio={16 / 9}
            className={classes.videoWrapper}
          >
            {children}
          </AspectRatio>
        );
      }}
    />
  );
}
